import type { SosEventResponse } from "@somewear/api";

export const shouldShowSosResolveAction = (
	isOrganizationAdmin: boolean,
	isAdminSosResolveEnabled: boolean,
) => isOrganizationAdmin && isAdminSosResolveEnabled;

export const shouldUpsertSosEvent = (
	event: SosEventResponse.AsObject,
	previousEvent?: SosEventResponse.AsObject,
) => {
	if (previousEvent === undefined || previousEvent.timestamp === undefined) return true;
	if (event.timestamp === undefined) return false;

	return (
		event.timestamp.seconds > previousEvent.timestamp.seconds ||
		(event.timestamp.seconds === previousEvent.timestamp.seconds &&
			event.timestamp.nanos > previousEvent.timestamp.nanos)
	);
};
